module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1038-1f9627276a26601c8628cf2e353fc422.png";